module.exports = __webpack_public_path__ + "img/edit.fd875f3f.svg";